import styled from "@emotion/styled";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

export const IconMenuContainer = styled(ResponsiveContainer)`
  cursor: pointer;

  path {
    fill: #000000;
  }

  ${touchOptimizedStyles}
`;
